import date from 'quasar/src/utils/date/date.js';;


const emojiRegex = /\[#b[0-9][0-9]]/g;
const emojiCodeFormat = "[#b%s]"

function singleDateTimeBuilder(obj, nowDateTime) {
    let sendDateTime = new Date(obj.sendDate).getTime()
    let waitSec = (nowDateTime - sendDateTime) / 1000
    if (waitSec < 60) {
        obj.webChatLabel = "刚刚"
    } else if (waitSec < 3600) {
        obj.webChatLabel = Math.floor(waitSec / 60) + "分钟前"
    } else if (waitSec < 3600 * 3) {
        obj.webChatLabel = Math.floor(waitSec / 3600) + "小时前"
    } else if (waitSec < 3600 * 24) {
        obj.webChatLabel = date.formatDate(sendDateTime, 'HH:mm')
    } else {
        obj.webChatLabel = date.formatDate(sendDateTime, 'YYYY-MM-DD HH:mm')
    }
}

export function messageTimeLabelInput(list, obj) {
    if (list) {
        //emoji
        let message = obj.message
        const emojiSet = new Set();
        let matches;
        while ((matches = emojiRegex.exec(message)) !== null) {
            emojiSet.add(matches[0])
        }
        if (emojiSet.size > 0) {
            for (let emoji of emojiSet) {
                const createImg = document.createElement("img");
                createImg.src = require("@/assets/emoji/bili/bili-" + emoji.substring(3, 5) + ".png")
                createImg.style = "height: 1.5rem;margin: 0 .15rem -.35rem .15rem"
                const imgElToString = createImg.outerHTML
                obj.message = obj.message.replaceAll(emoji, imgElToString)
            }
        }
        //date
        let nowDateTime = new Date()
        if (0 === list.length) {
            singleDateTimeBuilder(obj, nowDateTime);
            list.push(obj)
        } else {
            let lastSendDateTime = new Date(list[list.length - 1].sendDate).getTime()
            let waitLastSec = (nowDateTime - lastSendDateTime) / 1000
            if (waitLastSec < 600) {
                obj.webChatLabel = ""
            } else {
                singleDateTimeBuilder(obj, nowDateTime);
            }
            list.push(obj)
        }
    }
}

export function messageTimeLabelBuilder(list) {
    if (!list || 0 === list.length) {
        return
    }
    let nowDateTime = new Date()
    let lastIndex = list.length - 1
    for (let count = lastIndex; count >= 0; --count) {
        let sendDateTime = new Date(list[count].sendDate).getTime()
        let waitLastSec = null
        let waitSec = (nowDateTime - sendDateTime) / 1000
        if (count < lastIndex) {
            let lastSendDateTime = new Date(list[count + 1].sendDate).getTime()
            waitLastSec = (lastSendDateTime - sendDateTime) / 1000
        }
        if (waitSec < 60) {
            list[count].webChatLabel = "刚刚"
        } else if (waitSec < 3600) {
            list[count].webChatLabel = Math.floor(waitSec / 60) + "分钟前"
        } else if (waitSec < 3600 * 3) {
            list[count].webChatLabel = Math.floor(waitSec / 3600) + "小时前"
        } else if (waitSec < 3600 * 24) {
            list[count].webChatLabel = date.formatDate(sendDateTime, 'HH:mm')
        } else {
            list[count].webChatLabel = date.formatDate(sendDateTime, 'YYYY-MM-DD HH:mm')
        }
        if (waitLastSec && waitLastSec < 600) {
            list[count + 1].webChatLabel = ""
        }


        let message = list[count].message
        const emojiSet = new Set();
        let matches;
        while ((matches = emojiRegex.exec(message)) !== null) {
            emojiSet.add(matches[0])
        }
        if (emojiSet.size > 0) {
            for (let emoji of emojiSet) {
                const createImg = document.createElement("img");
                createImg.src = require("@/assets/emoji/bili/bili-" + emoji.substring(3, 5) + ".png")
                createImg.style = "height: 1.5rem;margin: 0 .15rem -.35rem .15rem"
                const imgElToString = createImg.outerHTML
                list[count].message = list[count].message.replaceAll(emoji, imgElToString)
            }
        }


    }

}


export function getAllEmojiAddress() {
    const imageFiles = require.context('@/assets/emoji/bili/', false, /\.(png|jpe?g|svg)$/);
    return imageFiles.keys().map(key => key.replace('./', ''));
}

export function buildEmojiCode(num) {
    return emojiCodeFormat.replace("%s", num)
}